module.exports = __webpack_public_path__ + "media/images/pages/enrichment/amb-banner-square-e6e95766fd454975c6b155159d294be6.jpg";